import React from 'react';
import Languages from '../../../../Languages/languages';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import { LanguageIcon, Mode, Settings } from '../../../../../Assets/Icons';
import styles from './settingsDialog.module.scss';
import Button from '../../../../Button/button';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import ModeSwitcher from '../../../../ModeSwitcher/modeSwitcher';

interface IProps {
  onClose:()=>void
}

const SettingsDialog:React.FC<IProps> = ({onClose}) => {
const {t} = useGeneralHooks();

  return (
    <div className={styles.container}>
    <div className={styles.header}>
      <div>
      <img src={Settings} alt='SettingsIcon' />
      <p>{t('Home.User_Drawer.Settings')}</p>
      </div>
    </div>
    <div className={styles.content}>
      <div className={styles.item}>
      <div className={styles.title}>
        <img src={LanguageIcon} alt='langIcon'/>
        <p>{t('Language')}</p>
      </div>
        <Languages/>
        </div>

        <div className={styles.item}>
      <div className={styles.title}>
        <img src={Mode} alt='modeIcon'/>
        <p>{t('Mode')}</p>
      </div>
        <ModeSwitcher/>
        </div>
        
        <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Close')}
                        onClick={onClose}
                    />
                </div>
    </div>
  </div>
  )
}

export default SettingsDialog
